import { Role } from '@agilox/common';
import { MenuPoint } from '@agilox/ui-common';
import { MenuPointUrl } from '../enums/menupoint-url.enum';
import { SettingsSubMenuUrl } from '../enums/settings-submenu.enum';
import { myMenuPoints } from './my-menupoints.const';

/** mobile menu points */
export const mobileMenupoints: Array<MenuPoint> = [
	myMenuPoints.dashboard,
	{
		name: 'menu.menu',
		url: '',
		icon: 'menu_hamburger',
		roles: [Role.superuser, Role.support, Role.service, Role.partner, Role.customer],
		submenus: [
			myMenuPoints.dashboard,
			myMenuPoints.fleet,
			myMenuPoints.release_notes,
			myMenuPoints.maas,
			{
				name: 'user.account',
				url: MenuPointUrl.SETTINGS,
				icon: 'account',
				roles: [],
				position: 'bottom',
				submenus: [
					{
						name: 'settings.personal.headline',
						url: SettingsSubMenuUrl.PERSONAL,
						icon: 'account',
						roles: [],
					} as MenuPoint,
					{
						name: 'settings.cookies.headline',
						url: SettingsSubMenuUrl.COOKIES,
						icon: 'cookies',
						roles: [],
					} as MenuPoint,
				],
			} as MenuPoint,
			myMenuPoints.help,
			myMenuPoints.logout,
		],
	},
];
